import BaseModel from "../BaseModel";

export default class SampleTestType extends BaseModel {
    static entity = 'sampleTestTypes';
    static primaryKey = "uuid";

    static fields() {
        return {
            uuid: this.attr(null),
            name: this.attr(null),
            description: this.attr(null),
            display_order: this.attr(null),
            created_by: this.attr(null),
            updated_by: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        }
    }
    static beforeSelect(types){
        return types.sort((a,b) => {
            return a.display_order - b.display_order
        })
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at']
    }
    static name(){
        return "SampleTestType"
    }

    static route(){
        return process.env.VUE_APP_RECORDED_API + '/sampleTestTypes';
    }
    
    static apiConfig = {
        ...super.apiConfig,
        headers: {
            "Accept": "application/json",
            "Authorization": process.env.VUE_APP_RECORDED_API_KEY,
            "VueRoute": window.location.href,
        }
    }
}
